export default __webpack_public_path__ + "static/2_19-54e21bef42730b6e600bfc733a7b2a09.png";